export default {
  subtitle: "Nøgler godkender anmodninger til Partner API'et. Send dem i x-api-key-headeren.",
  never_used: 'Aldrig brugt',
  revoke_confirm: 'Tilbagekald denne nøgle? Anmodninger, der bruger den, holder op med at virke med det samme.',
  columns: {
    name: 'Navn',
    key: 'Nøgle',
    status: 'Status',
    last_used_at: 'Sidst brugt',
    created_at: 'Oprettet',
  },
  statuses: {
    active: 'Aktiv',
    revoked: 'Tilbagekaldt',
  },
  buttons: {
    create: 'Opret nøgle',
    revoke: 'Tilbagekald',
  },
  toasts: {
    load_error: 'API-nøglerne kunne ikke indlæses.',
    error: 'Noget gik galt. Prøv igen.',
    revoked: 'API-nøgle tilbagekaldt.',
  },
};
